import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface TenantUser { id: string; email: string; name: string | null; role: string }
interface Tenant { id: string; name: string; slug: string; plan: string }

interface AuthState {
  token: string | null;
  user: TenantUser | null;
  tenant: Tenant | null;
  setSession: (token: string, user: TenantUser, tenant: Tenant) => void;
  clear: () => void;
}

export const useAuth = create<AuthState>()(
  persist(
    (set) => ({
      token: null, user: null, tenant: null,
      setSession: (token, user, tenant) => set({ token, user, tenant }),
      clear: () => set({ token: null, user: null, tenant: null }),
    }),
    { name: 'kardolive-customer-auth' },
  ),
);
